// extracted by mini-css-extract-plugin
module.exports = {"chestInventory":"_5da0cef","noChests":"_86c9059"};